import { useState, useEffect } from 'react';

const WELCOME_MODAL_KEY = 'welcomeModalShown';

/** Simple hash to avoid storing raw email in localStorage */
function hashEmail(email: string): string {
  let hash = 0;
  for (let i = 0; i < email.length; i++) {
    const char = email.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0; // Convert to 32bit integer
  }
  return hash.toString(36);
}

export const useWelcomeModal = (userEmail: string | null) => {
  const [shouldShow, setShouldShow] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!userEmail) {
      setIsReady(true);
      return;
    }

    // Check if user has already seen the welcome modal
    const key = `${WELCOME_MODAL_KEY}-${hashEmail(userEmail)}`;
    const hasSeenModal = localStorage.getItem(key);

    setShouldShow(hasSeenModal !== 'true');
    setIsReady(true);
  }, [userEmail]);

  const dismissModal = () => {
    if (!userEmail) return;

    const key = `${WELCOME_MODAL_KEY}-${hashEmail(userEmail)}`;
    // Always mark as seen when dismissed
    localStorage.setItem(key, 'true');
    setShouldShow(false);
  };

  const openModal = () => {
    setShouldShow(true);
  };

  const resetModal = () => {
    if (!userEmail) return;

    const key = `${WELCOME_MODAL_KEY}-${hashEmail(userEmail)}`;
    localStorage.removeItem(key);
    setShouldShow(true);
  };

  return {
    shouldShow,
    isReady,
    dismissModal,
    openModal,
    resetModal,
  };
};
